import Typography from "components/styled/Typography"
import { color, mq } from "helpers/styled"
import { useLocale, useT } from "react-polyglot-hooks"
import styled from "styled-components"

const Wrapper = styled(Typography)`
  margin-top: 25px;

  @media ${mq("lg")} {
    text-align: center;
  }

  a:first-child {
    margin-right: 5px;
  }

  a:last-child {
    margin-left: 5px;
  }
`

const Link = styled.a`
  color: ${color("deepPink")};
  text-decoration: underline;
`

function BlogLinks() {
  const t = useT()
  const locale = useLocale()

  return (
    <Wrapper variant="small" weight="light" color="deepPink">
      <Link href={`https://swipcar.com/${locale}/blog`} target="_blank">
        {t("landings.renting.news")}
      </Link>
      {" · "}
      <Link href={`https://swipcar.com/${locale}/opiniones`} target="_blank">
        {t("landings.renting.opinions")}
      </Link>
    </Wrapper>
  )
}

export default BlogLinks
